export enum Relations {
  LANGUAGE = 'language',
  SITE = 'site',
}
